import React from "react";

import Box from "@mui/material/Box";

import DetailRow from "./DetailRow";

import { AmountTypeEnum } from "api";

import { IbanInvoice } from "store/features/ibanInvoiceSlice";

import { getPriceFormat } from "shared/functions";

import dayjs from "dayjs";

import { amountTypeLabels } from "./variables";
import { styles } from "./styles";

interface DetailsProps {
  invoice: IbanInvoice | null;
}

const Details: React.FC<DetailsProps> = (props) => {
  const { invoice } = props;

  const {
    amount,
    amountType,
    publicName,
    organizationName,
    iban,
    identificationCode,
    paymentPurpose,
    invoiceDateTimeUtc,
    expirationDateTimeUtc,
    notes,
    clientNotes,
  } = invoice || {};

  return (
    <Box sx={styles.container}>
      <DetailRow
        label="Тип"
        value={amountTypeLabels[amountType as AmountTypeEnum] || "-"}
      />
      <DetailRow label="Сума" value={`${getPriceFormat(amount || 0)} ₴`} />
      <DetailRow
        label="Публічна назва компанії"
        value={publicName || "-"}
        maxLines={2}
      />
      <DetailRow
        label="Юр. назва компанії або ФОП"
        value={organizationName || "-"}
        maxLines={2}
      />
      <DetailRow label="IBAN" value={iban || "-"} />
      <DetailRow label="ЄДРПОУ / РНОКПП" value={identificationCode || "-"} />
      <DetailRow
        label="Призначення платежу"
        value={paymentPurpose || "-"}
        maxLines={3}
      />
      <DetailRow
        label="Дата створення"
        value={
          invoiceDateTimeUtc
            ? dayjs
                .utc(String(invoiceDateTimeUtc))
                .local()
                .format("DD MMM YY, HH:mm")
            : "-"
        }
      />
      <DetailRow
        label="Термін дії"
        value={
          expirationDateTimeUtc
            ? dayjs
                .utc(String(expirationDateTimeUtc))
                .local()
                .format("DD MMM YY, HH:mm")
            : "Необмежений"
        }
      />
      <DetailRow label="Нотатка для покупця" value={clientNotes || "-"} />
      <DetailRow
        label="Персональна нотатка"
        value={notes || "-"}
        maxLines={2}
      />
    </Box>
  );
};

export default Details;
